import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function PhotoGallery() {
  const [activeTab, setActiveTab] = useState(categories[0].slug);

  const activeCategory = categories.find((c) => c.slug === activeTab);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-primary-500 text-sm font-medium tracking-widest uppercase mb-3">
            Gallery
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            精选作品
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            每一张都是艺术品，每一个造型都是精心打造
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 mb-10">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveTab(cat.slug)}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        {activeCategory && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {activeCategory.items.map((item) => (
              <div
                key={item.id}
                className="group relative bg-background-50 rounded-lg overflow-hidden border border-background-200/70"
              >
                <div className="relative h-72 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  {item.tag && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-md">
                      {item.tag}
                    </span>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                    <Link
                      to={`/category?tab=${activeTab}`}
                      className="w-full py-2 bg-white/90 text-foreground-900 text-sm font-medium rounded-md text-center hover:bg-white transition-colors whitespace-nowrap cursor-pointer"
                    >
                      查看详情
                    </Link>
                  </div>
                </div>
                <div className="p-4">
                  <h4 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                    {item.title}
                  </h4>
                  <p className="text-foreground-600 text-xs leading-relaxed mb-2 line-clamp-2">
                    {item.description}
                  </p>
                  <p className="text-primary-500 text-sm font-semibold">{item.price}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-md hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部服务
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}